import { createStore } from 'redux';
import { install } from 'redux-loop';

import rootReducer from './reducers';

export default createStore(rootReducer, undefined, install());
